import * as React from 'react';
import { isEmpty } from 'ramda';
import ContainerDimensions from 'react-container-dimensions';
import { Flex, Box } from 'grid-styled';
import { number, object, array, func, oneOfType, bool } from 'prop-types';

import FlexChartLegend from './FlexChartLegend';
import GenericTooltip from './GenericTooltip';
import ChartSelection from './ChartSelection';
import { NoChart } from './NoContent';
import { ChartLegendData } from '../models';

const Container = Flex.extend`
  position: relative;
  flex-direction: column;
`;

const ChartAndLegend = ({
  width,
  height,
  legendData,
  chartData,
  resetSelectionOnClick,
  chartComponent: ChartComponent,
  ...rest
}) => {
  if (!chartData || isEmpty(chartData)) return <NoChart />;

  return (
    <ChartSelection>
      {selectionProps => (
        <Container style={{ width, height }}>
          <Box
            style={{ overflow: 'hidden', flex: '1 1 auto' }}
            onClick={() => {
              if (resetSelectionOnClick && selectionProps.selectedId) {
                selectionProps.setSelected(null);
              }
            }}
          >
            <ContainerDimensions>
              {({ width, height }) => (
                <React.Fragment>
                  <ChartComponent
                    width={width}
                    height={height}
                    legendData={legendData}
                    chartData={chartData}
                    {...selectionProps}
                    {...rest}
                  />
                  {selectionProps.tooltipProps && (
                    <GenericTooltip
                      bounds={{ width, height, padding: 10 }}
                      {...selectionProps.tooltipProps}
                    />
                  )}
                </React.Fragment>
              )}
            </ContainerDimensions>
          </Box>
          <Box p={24}>
            <FlexChartLegend
              legendData={legendData}
              height={100}
              {...selectionProps}
            />
          </Box>
        </Container>
      )}
    </ChartSelection>
  );
};

ChartAndLegend.propTypes = {
  width: number.isRequired,
  height: number.isRequired,
  legendData: ChartLegendData.isRequired,
  chartData: oneOfType([object, array]).isRequired,
  chartComponent: func.isRequired,
  resetSelectionOnClick: bool,
};

export default ChartAndLegend;



// WEBPACK FOOTER //
// ./src/components/ChartAndLegend.jsx